import axios from 'axios'
import { useEffect, useState } from 'react'

import { OptionInterface } from '../../../common/components'

const ENDPOINT = `${process.env.REACT_APP_API_URL}/v1/classrooms`

const INITIAL_STATE = {
  loading: false,
  data: null,
  error: null,
  getSchoolClass: () => undefined
}

interface State {
  loading: boolean
  error: string | null
  data: OptionInterface[] | null
  getSchoolClass: any
}

interface QueryParams {
  school: string | number
  schoolYear: string | number
}

const mapValues = (
  values: Array<{ id: string; name: string }>
): OptionInterface[] => {
  return values.map(value => ({
    label: value.name,
    value: value.id
  }))
}

const useGetSchoolClasses = (): State => {
  const [state, setState] = useState<State>(INITIAL_STATE)

  const query = async (params: QueryParams) => {
    setState(current => ({ ...current, loading: true }))
    try {
      const { school, schoolYear } = params
      const { data } = await axios.get(ENDPOINT, {
        params: { school_id: school, grade_id: schoolYear }
      })
      if (data.expired) {
        return
      }

      setState({
        data: mapValues(data),
        loading: false,
        error: null,
        getSchoolClass: query
      })
    } catch (e) {
      setState({
        ...INITIAL_STATE,
        error: 'Ocorreu um erro ao buscar as escolas disponíveis'
      })
    }
  }

  useEffect(() => {
    query({ school: '', schoolYear: '' })
  }, [])

  return state
}

export default useGetSchoolClasses
